"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.toggleSideMenu = exports.setMode = exports.linkFailure = exports.linkSuccess = exports.linkRequest = void 0;
const ActionTypes = require("../../actionTypes/vektorio/linkFolders");
const linkRequest = (payload) => ({
    type: ActionTypes.LINK_REQUEST,
    payload
});
exports.linkRequest = linkRequest;
const linkSuccess = () => ({
    type: ActionTypes.LINK_SUCCESS
});
exports.linkSuccess = linkSuccess;
const linkFailure = (payload) => ({
    type: ActionTypes.LINK_FAILURE,
    payload
});
exports.linkFailure = linkFailure;
const setMode = (payload) => ({
    type: ActionTypes.SET_MODE,
    payload
});
exports.setMode = setMode;
const toggleSideMenu = () => ({
    type: ActionTypes.TOGGLE_SIDE_MENU
});
exports.toggleSideMenu = toggleSideMenu;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=linkFolders.js.map